import { markRaw, reactive } from "vue";

// Toasts stack down from the top right corner, GAP px apart, the way mosha-vue-toastify
// (which this replaces) laid them out.
export const GAP = 12;
const REMOVE_AFTER_MS = 1000;

export const toasts = reactive([]);
let nextId = 0;

const shown = () => toasts.filter((toast) => !toast.closing);

export const closeToast = (id) => {
  const toast = shown().find((t) => t.id === id);
  if (!toast) return;

  // The ones below it move up into its place.
  const freed = (toast.el?.offsetHeight ?? 0) + GAP;
  const index = toasts.indexOf(toast);
  toasts.slice(index + 1).forEach((t) => {
    if (!t.closing) Object.assign(t, { offset: t.offset - freed });
  });

  toast.closing = true;
  setTimeout(() => toasts.splice(toasts.indexOf(toast), 1), REMOVE_AFTER_MS);
};

export const clearToasts = () => shown().forEach((toast) => closeToast(toast.id));

// Renders `component` with `props` in a new toast. A timeout of 0 or less keeps it open
// until it is closed, and hides the progress bar.
export const createToast = (component, props, { type = "default", timeout = 5000 } = {}) => {
  const id = nextId;
  nextId += 1;
  // Pushed on the next turn so a toast created right after another one is placed below it,
  // once that one has been rendered and can be measured.
  setTimeout(() => {
    const offset = shown().reduce((top, t) => top + (t.el?.offsetHeight ?? 0) + GAP, GAP);
    toasts.push({
      id,
      component: markRaw(component),
      props,
      type,
      timeout,
      offset,
      closing: false,
      el: null,
    });
  }, 1);
  return { close: () => closeToast(id) };
};
